import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { OrderService } from '../../services/order.service';

@Component({
    selector: 'app-export-number-dialog',
    templateUrl: 'export-number-dialog.component.html'
})
export class ExportNumberDialogComponent {

    /**
     * phoneNumberIds: number[] 
     */
    @ViewChild('selectedPhoneNumbers')
    public phoneNumberIds: MatSelectionList;

    /**
     * Constructor
     * @param dialogRef 
     * @param data 
     */
    constructor(
        protected service: OrderService,
        public dialogRef: MatDialogRef<ExportNumberDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { orderId: number, destinationCarrierId?: string, phoneNumbers: number[] }
    ) { }

    /**
     * Save data
     */
    public save(): void {
        this.service.exportPhoneNumbers(this.data.orderId, this.data.destinationCarrierId, this.phoneNumberIds.selectedOptions.selected.map(x => x.value))
            .subscribe(x => this.dialogRef.close());
    }

    /**
     * Closes the dialog
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}